"use client";

import React from "react";
import { Zap, TicketPercent, Search } from "lucide-react";
import { useTranslations } from "next-intl";

const HowWorksSection = () => {
  const t = useTranslations("HomePageFlights");
  const steps = t.raw("HowWorksSection.steps") as {
    title: string;
    description: string;
  }[];

  const icons = [Search, TicketPercent, Zap];
  const bgColors = [
    "bg-sleap-purple-50 dark:bg-sleap-purple-50",
    "bg-sleap-black-50 dark:bg-sleap-black-50",
    "bg-sleap-light-blue-50 dark:bg-sleap-light-blue-50",
  ];
  const textColors = [
    "text-sleap-gray-950 dark:text-sleap-gray-950",
    "text-white dark:text-white",
    "text-sleap-gray-950 dark:text-sleap-gray-950",
  ];
  const descColors = [
    "text-sleap-gray-600 dark:text-sleap-gray-600",
    "text-white dark:text-white",
    "text-sleap-gray-600 dark:text-sleap-gray-600",
  ];

  return (
    <section className="w-full py-8 px-4 bg-white dark:bg-dark text-sleap-gray-950 dark:text-white rounded-xl m-0 md:py-16">
      <div className="w-full max-w-6xl mx-auto">
        <h2 className="mb-14 text-center font-inter text-3xl font-semibold text-sleap-gray-950 dark:text-white">
          {t("HowWorksSection.heading.part1")}{" "}
          <span className="bg-gradient-to-b from-sleap-blue-100 to-sleap-purple-300 bg-clip-text text-transparent">
            {t("HowWorksSection.heading.highlight")}
          </span>{" "}
          {t("HowWorksSection.heading.part2")}
        </h2>
        <ul className="flex flex-col gap-6 md:flex-row md:gap-8">
          {steps.map((step, index) => {
            const Icon = icons[index];
            return (
              <li key={index}>
                <div
                  className={`p-6 pb-9 ${bgColors[index]} rounded-xl shadow-rooms-card`}
                >
                  <span className="w-14 h-14 bg-white dark:bg-white rounded-full flex justify-center mb-11 items-center">
                    <Icon
                      className={`${
                        textColors[index] === "text-white dark:text-white"
                          ? "text-sleap-gray-950 dark:text-sleap-gray-950"
                          : textColors[index]
                      }`}
                    />
                  </span>
                  <h3
                    className={`font-inter text-2xl font-semibold mb-4 ${textColors[index]}`}
                  >
                    {step.title}
                  </h3>
                  <p className={`font-inter text-sm ${descColors[index]}`}>
                    {step.description}
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default HowWorksSection;
